<!--
 * @Author: 教练
 * @Date: 2020-07-27 18:34:19
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 17:32:28
 * @FilePath: \car-demo\src\components\InstructorItem.vue
-->
<template>
	<div v-if="item" class="instructor flex">
		<template v-if="index >= 0">
			<img
				v-if="index <= 2"
				class="icon"
				:src="require('@/assets/images/jiangbei-' + index + '.png')"
				alt="..."
			/>
			<span class="icon" v-else>{{ index + 1 }}</span>
		</template>
		<img
			class="avatar"
			:src="item.head_pic"
			alt=""
		/>

		<ul :style="borderBottomStyle">
			<li class="flex j-between a-center">
				<span class="name flex a-center">
					<span>{{item.nickname}}</span>
					<img v-show="item.is_own_shop == 1"
						src="../assets/images/vip-gold.png"
						alt=""
						width="14"
						height="14"
						style="margin: 0 5px"
					/>
					<img v-show="!(sourcePage !='' && Number(item.reward_gift) < Number(item.coach_red_open_price))" src="../assets/images/hot-f.png" alt="" width="24" height="14" />
				</span>
				<a href="javascript:;" class="btn" @click.stop="handleClick">去打赏</a>
			</li>

			<slot name="desc">
				<li>{{item.store_name}}</li>
				<li v-if="item.num>0">已收到{{item.num}}次打赏</li>
				<li v-else>还未收到打赏</li>
				<li>教龄：{{item.level_category}}年 | 学员：{{ item.fake_consult_count }}人</li>
			</slot>
		</ul>
	</div>
</template>

<script>
import cache from "../utils/cache";

export default {
	name: 'instructor',
	props: {
		index: {
			type: [String, Number],
			default: -1,
		},
		item:{
			type: Object
		},
		//教练列表 引入才判断是否点亮 红人榜标识
		//其他页面进入默认点量
		sourcePage:{type:String,default:''},
		borderBottom: Boolean,
	},
	created() {

	},
	computed: {
		borderBottomStyle() {
			if (this.borderBottom) {
				return {
					'border-bottom': '1px solid #dcdcdc',
					'padding-bottom': '10px',
				}
			}
		},
	},
  methods: {
		handleClick() {
      cache.set('jiaolian', JSON.stringify(this.item),86400*30);
			this.$router.push({ name: 'Reward'})
		},
	}
}
</script>

<style lang="less" scoped>
.btn {
	display: block;
	width: 60px;
	height: 28px;
	line-height: 28px;
	text-align: center;
	background: rgba(255, 255, 255, 1);
	border: 1px solid rgba(235, 39, 59, 1);
	color: rgba(235, 39, 59, 1);
	border-radius: 15px;
	font-size: 12px;
}

ul {
	flex-grow: 1;
}
li {
	font-size: 13px;
	color: #666;
	.name {
		font-size: 15px;
		color: #333;
		font-weight: bold;
	}
	&:not(:last-child) {
		margin-bottom: 10px;
	}
}
.icon {
	flex-shrink: 1;
	display: inline-block;
	width: 24px;
	height: 24px;
	margin-top: 9px;
	font-size: 16px;
	color: #333;
	font-weight: bold;
	text-align: center;
}
.avatar {
	flex-shrink: 1;
	display: inline-block;
	width: 44px;
	height: 44px;
	border-radius: 50%;
	margin: 0 10px;
}
</style>
